<app-nav-menu></app-nav-menu>
<p-toast></p-toast>
<p-confirmDialog [closable]="false">
  <ng-template pTemplate="message" let-message>
    <div class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border">
      <i class="pi pi-exclamation-circle text-6xl text-primary-500"></i>
      <p>{{ message.message }}</p>
    </div>
  </ng-template>
</p-confirmDialog>

@if (loader) {
  <div style="width: 100%; height: 105vh; position: fixed; background: #e8e8e8de; z-index: 500; top: 0;">
    <div class="text-center" style="width: 100%; display: flex; justify-content: center; align-items: center; text-align: center; height: 100%;">
      <div class="spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
}

<div class="offline-main-container">
  <div class="offline-content-wrapper">
    <!-- Left Column: Details & Actions -->
    <div class="offline-left-col">
      <!-- Status Card -->
      <div class="flight-card status-card">
        <div class="status-card-header">
          <div class="status-row">
            <span class="status-label">Status:</span>
            <span class="status-badge">{{offlineObj.bookingStatusName || 'N/A'}}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Requesting Agency:</span>
            <span class="info-val">{{offlineObj.requestingAgency || 'N/A'}}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Requester Name:</span>
            <span class="info-val">{{offlineObj.requestingUserName || 'N/A'}}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Booking Id:</span>
            <span class="info-val booking-id">{{offlineObj.offlineId}}</span>
          </div>
        </div>

        <div class="status-card-actions">
          <div class="btn-group-actions">
            @if (request == 'Agent') {
              <button class="button-42 btn-action" (click)="UpdateOfflineRequest(5)">Invoiced</button>
              <button class="button-42 btn-action" (click)="UpdateOfflineRequest(6)">Removed From List</button>
              <button class="button-42 btn-action" (click)="UpdateOfflineRequest(8)">Void</button>
            }
            <button class="button-42 btn-back" (click)="CheckROUTE()">
              <i class="pi pi-arrow-left mr-1"></i> Back To List
            </button>
          </div>
        </div>
      </div>

      <!-- Booking Details Card -->
      <div class="flight-card details-card">
        <div class="details-card-header">
          <div class="void-badge">
            <i class="pi pi-ban mr-1"></i> Offline Void
          </div>
          <div class="d-flex justify-content-between align-items-center w-100 mt-2 mb-2">
            <div class="departure-label">
              <i class="pi pi-info-circle mr-1"></i> Booking Details
            </div>
            <button class="button-10" (click)="viewProfileOpen()">
              <i class="pi pi-eye mr-1"></i> View Details
            </button>
          </div>
        </div>

        <div class="details-summary-grid">
          <div class="summary-item">
            <span class="summary-label">Booking Source</span>
            <span class="summary-val">{{offlineObj.bookingSource || '-'}}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">PNR</span>
            <span class="summary-val pnr-code">{{offlineObj.pnr || '-'}}</span>
          </div>
        </div>

        <div class="travel-info-section mt-3">
          <div class="table-section-title">
            <i class="pi pi-ticket mr-1"></i> Travel Information
          </div>
          <div class="table-responsive">
            <table class="table custom-passengers-table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Ticket No</th>
                </tr>
              </thead>
              <tbody>
                @for (passenger of offlineObj.passengerList; track passenger; let u = $index) {
                  <tr>
                    <td class="text-muted">{{u + 1}}</td>
                    <td class="ticket-no-cell">{{passenger.ticketNo || '-'}}</td>
                  </tr>
                }
                @if (!offlineObj.passengerList || offlineObj.passengerList.length === 0) {
                  <tr>
                    <td colspan="2" class="text-center text-muted py-3">No passengers found</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Column: Chat Section -->
    <div class="offline-right-col">
      @if (offlineObj.currentBookingStatus > 0) {
        <div class="chat-container">
          <app-chat (dataToParent)="handleData($event)" [GettingUniqueData]="basicDataforChat"></app-chat>
        </div>
      }
    </div>
  </div>
</div>

<!-- ============================================================== -->
<!-- DIALOG 1: VIEW DETAILS (Read-Only)                              -->
<!-- ============================================================== -->
<p-dialog header="View Details" [(visible)]="viewprofile" [modal]="true"
  [style]="{width: '52vw', minWidth: '420px', maxWidth: '680px'}"
  [breakpoints]="{'960px': '75vw', '640px': '92vw'}"
  [draggable]="false" [resizable]="false"
  styleClass="offline-void-dialog">

  <div class="offline-dialog-content">
    <div class="row m-0">
      <!-- Booking Source -->
      <div class="col-md-6 mb-3 px-2">
        <label class="form-label" for="bookingSourceView">Booking Source</label>
        <p-select class="segmentDropdown" id="bookingSourceView" [options]="offlineBookingSource" [disabled]="true"
          name="bookingSourceView" [(ngModel)]="offlineObj.bookingSource"
          placeholder="Select" optionLabel="offlineSourceName" optionValue="offlineSourceName">
        </p-select>
      </div>

      <!-- PNR -->
      <div class="col-md-6 mb-3 px-2">
        <label class="form-label" for="pnrView">PNR</label>
        <input type="text" id="pnrView" [(ngModel)]="offlineObj.pnr" name="pnrView" [disabled]="true" class="inputStyle" />
      </div>

      <!-- Remarks -->
      <div class="col-12 mb-3 px-2">
        <label class="form-label" for="remarksView">Remarks</label>
        <input type="text" id="remarksView" [(ngModel)]="offlineObj.remarks" [disabled]="true" name="remarksView" class="inputStyle" />
      </div>
    </div>

    @if (offlineObj.passengerList != null && offlineObj.passengerList.length > 0) {
      <div class="travel-section px-2 mt-2">
        <div class="travel-info-header">
          <span class="section-title">
            <i class="pi pi-ticket mr-1"></i> Travel Information
          </span>
        </div>

        <div class="passengers-list">
          @for (passenger of offlineObj.passengerList; track passenger; let p = $index) {
            <div class="passenger-card">
              <div class="passenger-card-header">
                <span class="passenger-badge">
                  <i class="pi pi-user mr-1"></i> Passenger {{p + 1}}
                </span>
              </div>
              <div class="passenger-card-body">
                <div class="form-group mb-0">
                  <label class="form-label">Ticket No</label>
                  <input type="text" [(ngModel)]="passenger.ticketNo" [name]="'tktnoView' + p" [disabled]="true" class="inputStyle" />
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }

    <div class="modal-action-footer">
      <button type="button" class="btn-cancel" (click)="viewprofile = false">Close</button>
    </div>
  </div>
</p-dialog>

<!-- ============================================================== -->
<!-- DIALOG 2: OFFLINE VOID (Create / Edit Form)                     -->
<!-- ============================================================== -->
<p-dialog header="Offline Void" [(visible)]="ticketProfile" [modal]="true"
  [style]="{width: '52vw', minWidth: '420px', maxWidth: '680px'}"
  [breakpoints]="{'960px': '75vw', '640px': '92vw'}"
  [draggable]="false" [resizable]="false" [closable]="forrequest"
  styleClass="offline-void-dialog">

  <form #offlineTicketForm="ngForm" (ngSubmit)="OtherRequestCreateUpdate()" class="offline-dialog-content">
    <div class="row m-0">
      <!-- Booking Source -->
      <div class="col-md-6 mb-3 px-2">
        <label class="form-label" for="bookingSourceSelect">
          Booking Source <span class="required-star">*</span>
        </label>
        <p-select class="segmentDropdown" id="bookingSourceSelect" [options]="offlineBookingSource"
          [disabled]="isFormDisabled || (type != 'Create' && request == 'User')"
          name="bookingSource" [(ngModel)]="offlineObj.bookingSource" #bookingSource="ngModel" required
          [ngClass]="{'invalid_Prime_Error': bookingSource.invalid && bookingSource.touched}"
          placeholder="Select Booking Source" optionLabel="offlineSourceName" optionValue="offlineSourceName">
        </p-select>
        @if (bookingSource.invalid && bookingSource.touched) {
          <span class="inputErrors">
            <i class="pi pi-exclamation-circle mr-1"></i> Booking Source Required!
          </span>
        }
      </div>

      <!-- PNR -->
      <div class="col-md-6 mb-3 px-2">
        <label class="form-label" for="pnrInput">
          PNR <span class="required-star">*</span>
        </label>
        <input type="text" id="pnrInput" [(ngModel)]="offlineObj.pnr" name="pnr" #pnr="ngModel" required
          (input)="offlineObj.pnr = offlineObj.pnr.toUpperCase()"
          [disabled]="request == 'Agent' || isFormDisabled || (type != 'Create' && request == 'User')"
          class="inputStyle"
          [ngClass]="{'invalid-Error': pnr.invalid && pnr.touched}"
          autocomplete="off" placeholder="Enter PNR" />
        @if (pnr.invalid && pnr.touched) {
          <span class="inputErrors">
            <i class="pi pi-exclamation-circle mr-1"></i> PNR Required!
          </span>
        }
      </div>

      <!-- Remarks -->
      <div class="col-12 mb-3 px-2">
        <label class="form-label" for="remarksInput">Remarks</label>
        <input type="text" id="remarksInput" [(ngModel)]="offlineObj.remarks" [disabled]="isFormDisabled"
          name="remarks" class="inputStyle" placeholder="Enter Remarks (Optional)" autocomplete="off" />
      </div>
    </div>

    <!-- Travel Information Section -->
    <div class="travel-section px-2 mt-2">
      <div class="travel-info-header">
        <span class="section-title">
          <i class="pi pi-ticket mr-1"></i> Travel Information
        </span>
        @if (!submithide) {
          <button type="button" (click)="addPassenger()" class="btn-add-passenger">
            <i class="pi pi-plus mr-1"></i> Add Passenger
          </button>
        }
      </div>

      <div class="passengers-list">
        @for (passenger of offlineObj.passengerList; track passenger; let p = $index) {
          <div class="passenger-card">
            <div class="passenger-card-header">
              <span class="passenger-badge">
                <i class="pi pi-user mr-1"></i> Passenger {{p + 1}}
              </span>
              @if (p > 0 && !submithide) {
                <button type="button" class="btn-remove-passenger" (click)="removePassenger(p)" title="Remove Passenger">
                  <i class="pi pi-trash mr-1"></i> Remove
                </button>
              }
            </div>
            <div class="passenger-card-body">
              <div class="form-group mb-0">
                <label class="form-label" [for]="'tktno' + p">
                  Ticket No <span class="required-star">*</span>
                </label>
                <input type="text" [(ngModel)]="passenger.ticketNo" [name]="'tktno' + p" #tktno="ngModel" required
                  [disabled]="request == 'Agent' || isFormDisabled" class="inputStyle" [id]="'tktno' + p"
                  [ngClass]="{'invalid-Error': tktno.invalid && tktno.touched}" autocomplete="off"
                  placeholder="Enter Ticket Number" />
                @if (tktno.invalid && tktno.touched) {
                  <span class="inputErrors">
                    <i class="pi pi-exclamation-circle mr-1"></i> Ticket No Required!
                  </span>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <!-- Submit / Cancel Action Buttons -->
    @if (!submithide) {
      <div class="modal-action-footer">
        <button type="button" class="btn-cancel" (click)="closeprofile()">Cancel</button>
        <button type="submit" class="btn-submit" [disabled]="offlineTicketForm.invalid">
          <i class="pi pi-check mr-1"></i> Submit
        </button>
      </div>
    }
  </form>
</p-dialog>
